// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnRdv {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #007bff;
  margin: 0.2rem;
}

.divBtnRdv {
  display: flex;
  justify-content: flex-end;
}

ion-item {
  --ion-item-background:white;
}

ion-content {
  --ion-background-color: rgb(247, 247, 247);
}

.widget {
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
}

.widget-next-appointment {
  height: 218px;
  width: 100%;
}

.widget-my-client {
  height: 261px;
  width: 100%;
}

.widget-last-payments {
  height: 362px;
  width: 100%;
}

.widget-some-infos {
  height: 244px;
  width: 100%;
}

.drop-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.3s ease-in-out;
}

.drag-item {
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
  cursor: grab;
}

.cdk-drag-preview {
  transform: scale(1.05);
  opacity: 0.9;
}

.cdk-drag-placeholder {
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
}

.cdk-drag-over {
  transform: scale(1.02);
  transition: transform 0.2s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/dashboards/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,yBAAA;AAJF;;AAUA;EACE,2BAAA;AAPF;;AAWA;EACE,0CAAA;AARF;;AAWA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AARF;;AAYA;EACE,aAAA;EACA,WAAA;AATF;;AAYA;EACE,aAAA;EACA,WAAA;AATF;;AAaA;EACE,aAAA;EACA,WAAA;AAVF;;AAcA;EACE,aAAA;EACA,WAAA;AAXF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gCAAA;AAZF;;AAeA;EACE,gEAAA;EACA,YAAA;AAZF;;AAeA;EACE,sBAAA;EACA,YAAA;AAZF;;AAeA;EACE,YAAA;EACA,oCAAA;AAZF;;AAeA;EACE,sBAAA;EACA,sCAAA;AAZF","sourcesContent":["\r\n\r\n\r\n//RDV \r\n\r\n.btnRdv{\r\n  width: 2rem;\r\n  height: 2rem;\r\n  border-radius: 50%;\r\n  background-color: #007bff;\r\n  margin: 0.2rem;\r\n}\r\n\r\n.divBtnRdv{\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n\r\n\r\n\r\nion-item{\r\n  --ion-item-background:white;\r\n}\r\n\r\n\r\nion-content{\r\n  --ion-background-color : rgb(247, 247, 247);   \r\n}\r\n\r\n.widget {\r\n  width: 100%;\r\n  margin-top : 5px;\r\n  margin-bottom: 5px;\r\n\r\n}\r\n\r\n.widget-next-appointment {\r\n  height: 218px; \r\n  width: 100%;\r\n}\r\n\r\n.widget-my-client {\r\n  height: 261px;\r\n  width: 100%;\r\n\r\n}\r\n\r\n.widget-last-payments {\r\n  height: 362px;\r\n  width: 100%;\r\n\r\n}\r\n\r\n.widget-some-infos {\r\n  height: 244px;\r\n  width: 100%;\r\n\r\n}\r\n\r\n.drop-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.drag-item {\r\n  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;\r\n  cursor: grab;\r\n}\r\n\r\n.cdk-drag-preview {\r\n  transform: scale(1.05);\r\n  opacity: 0.9;\r\n}\r\n\r\n.cdk-drag-placeholder {\r\n  opacity: 0.5;\r\n  transition: opacity 0.2s ease-in-out;\r\n}\r\n\r\n.cdk-drag-over {\r\n  transform: scale(1.02);\r\n  transition: transform 0.2s ease-in-out;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
